// sensitiveRoutes.js — issue #67 (follow-up to #62).
//
// Routes that can carry a live bearer token (in the query string — audit-
// link token, workspace invite token, anonymous outcome-response magic-
// link token — or directly as a path segment) or otherwise render private
// content. PostHog session recording is disabled on all of them — see
// App.js's route-change effect.
//
// #62 covered /analyses/* and /embed/* (the routes the original leak was
// found on). #67 widens this to /invite and /outcomes/prompt, which carry
// the same kind of live token but weren't in scope for #62.
//
// Code review (PR #113) — /r/:token (RegulatorView) was missed: `token`
// there is a live bearer credential carried directly as a path segment
// (not a query param), and the URL never changes for the whole viewing
// session (no redirect away, unlike /s/:slug or /analysis/:id), so it's
// arguably more exposed than the query-param cases above — it never
// leaves the URL bar. Added here.
//
// The token value itself (the `?token=` query param, and the /r/:token path
// segment) is stripped from every captured event regardless of route by
// the before_send redaction in public/posthog-redact.js — this regex only
// governs the separate, route-scoped session-recording opt-out.
//
// Case-insensitive (PR #113 review): React Router matches routes
// case-insensitively (`caseSensitive` is never set), so /R/<token> renders
// RegulatorView and /Analyses/<id> renders the private analysis exactly like
// their lowercase forms. A case-sensitive guard left session recording ON for
// every mixed-case spelling. public/posthog-redact.js matches /r/ the same way.
const SENSITIVE_ROUTE_RE = /^\/(analyses|embed|invite|outcomes\/prompt|r)(\/|$)/i;

export function isSensitiveRoute(pathname) {
    return SENSITIVE_ROUTE_RE.test(pathname || "");
}
